import { BaseState } from '../types';

// Actions

export enum AuthTypes {
  AuthRequest = '@auth/AUTH_REQUEST',
  AuthSuccess = '@auth/AUTH_SUCCESS',
  AuthFailure = '@auth/AUTH_FAILURE',
  Logout = '@auth/LOGOUT',
}

// Async Response

export interface AuthResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}

export interface AuthRequestActionPayload {
  email: string;
  password: string;
}

// State

export interface AuthState extends BaseState {
  readonly userInfo: AuthResponse | null;
}
